import React from 'react';
import { Flex } from '@chakra-ui/react';
import { ActiveGoalsWidget } from 'src/features/Goals/components/molecules/ActiveGoalsWidget';
import { OverviewAddGoalButton } from 'src/features/Goals/components/molecules/OverviewAddGoalButton';

export const GenAIActionButtons: React.FC = () => {
  return (
    <Flex
      alignItems={{ base: 'stretch', lg: 'end' }}
      direction={{ base: 'column', lg: 'row' }}
      gap={{ base: 4, lg: 24 }}
      w={{ base: '100%', lg: 'auto' }}>
      <ActiveGoalsWidget />

      <Flex
        gap={4}
        direction={{ base: 'column', sm: 'row' }}
        w={{ base: '100%', lg: 'auto' }}>
        <OverviewAddGoalButton />
      </Flex>
    </Flex>
  );
};
